import AdsList from "../../components/ads/AdsList"

export const AdsPage = () => {

    return (
        <AdsList />
    )
}